// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/navaid-serviceability-and-reporting.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/navaid-serviceability-and-reporting/navaid-serviceability-and-reporting.js';
import g1 from '../lessons/navigation/navaid-serviceability-and-reporting/vor-station-identification.js';

mount([g0, g1]);
